import * as React from 'react';

import { GMetrixDialog } from 'components/GMetrixDialog/GMetrixDialog';
import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { Container } from 'react-bootstrap';
import { useIntl } from 'react-intl';

interface ReportCustomModalProps {
    description: string;

    /** When true, modal is in edit mode; otherwise it's creating a new custom report. */
    isEditing: boolean;
    name: string;
    onCancel: () => void;
    onDescriptionChange: (v: string) => void;
    onNameChange: (v: string) => void;
    onSave: () => void;
    show: boolean;
}

export const ReportCustomModal = (props: ReportCustomModalProps) => {

    const {
        name,
        description,
        onCancel,
        onDescriptionChange,
        onNameChange,
        onSave,
        show
    } = props;

    const { formatMessage } = useIntl();

    return (
        <GMetrixDialog
            actionButtonClick={onSave}
            actionButtonDisabled={!name || !description}
            actionButtonText={formatMessage({ id: 'save.d44082ae', defaultMessage: 'Save' })}
            dialogLabel={formatMessage({ id: 'save_custom_report.5dc3e4df', defaultMessage: 'Save Custom Report' })}
            onCancel={onCancel}
            show={show}
            size="lg"
        >
            <Container>
                <GMetrixInput
                    label={formatMessage({ id: 'name.5458f379', defaultMessage: 'Name' })}
                    onChange={e => onNameChange(e.target.value)}
                    value={name}
                />
                <GMetrixInput
                    as="textarea"
                    label={formatMessage({ id: 'description.e1c24171', defaultMessage: 'Description', description: 'Formulario' })}
                    onChange={e => onDescriptionChange(e.target.value)}
                    rows={3}
                    value={description}
                />
            </Container>
        </GMetrixDialog>
    );

};
